export const SET_COMPANIES = 'SET_COMPANIES';
export const SET_RECENT_COMPANIES = 'SET_RECENT_COMPANIES';
export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY';
export const ADD_RECENT_COMPANY = 'ADD_RECENT_COMPANY';
export const FILTER_COMPANIES = 'FILTER_COMPANIES';
export const SHOW_RELOAD_COMPANIES = 'companySwitcher/showReloadCompanies';
export const SHOW_RELOAD_RECENTS = 'companySwitcher/showReloadRecents';
export const SET_IS_RELOAD = 'companySwitcher/setIsReload';

export const setCompanies = (companies, recentCompanies = []) => {
    let _companies = _validateCompanies(companies),
        _recentCompanies = _validateCompanies(recentCompanies);

    return {
        type: SET_COMPANIES,
        companies: _companies,
        recentCompanies: _recentCompanies
    }
};

export const setRecentCompanies = (recentCompanies) => {
    let _recentCompanies = _validateCompanies(recentCompanies);
    return {
        type: SET_RECENT_COMPANIES,
        recentCompanies: _recentCompanies
    }
};

export const setSelectedCompany = (selectedCompany) => {
    return {
        type: SET_SELECTED_COMPANY,
        selectedCompany
    }
};

export const addRecentCompany = (company) => {
    return {
        type: ADD_RECENT_COMPANY,
        company
    }
};

export const filterCompanies = (filterText) => {
    return {
        type: FILTER_COMPANIES,
        filterText
    }
};

export const showReloadCompanies = show => ({
    type: SHOW_RELOAD_COMPANIES,
    show
});

export const showReloadRecents = show => ({
    type: SHOW_RELOAD_RECENTS,
    show
});

export const setIsReload = isReload => ({
    type: SET_IS_RELOAD,
    isReload
});
/**
 * Verifies that 'companies' is an Array and returns, otherwise it returns an empty array
 * @param companies
 * @returns {Array}
 * @private
 */
function _validateCompanies(companies){
    return Array.isArray(companies) ? companies : [];
}